import { EventAdapter } from '~analytics/adapters/EventAdapter';
import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

export type CloseAction =
  | 'close_button'
  | 'ai'
  | 'blank'
  | 'import'
  | 'ai-import';

interface AddQuizModalEventAdapterParams {
  source: 'personal_library' | 'shared_library';
  action: 'open' | 'close';
  close_action?: CloseAction;
}

type AddQuizModalEventData = {
  source: 'personal_library' | 'shared_library';
  action: 'open' | 'close';
  close_action?: CloseAction;
};

export class AddQuizModalEventAdapter extends EventAdapter<AddQuizModalEventData> {
  protected intercomEventKey = null;

  constructor({
    source,
    action,
    close_action,
  }: AddQuizModalEventAdapterParams) {
    super();

    this.eventData = {
      source,
      action,
      close_action,
    };
  }
  protected amplitudeEventFunction = function addQuizModalEvent(
    event: AddQuizModalEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.AddQuizModal, event);
  };
}
